
import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { SessionStorageService } from 'ngx-webstorage'; 


@Component({
  selector: 'cbic-gst',
  templateUrl: './gst.component.html',
  styleUrls: ['./gst.component.scss'],
})
export class GSTComponent implements OnInit {
  translateService: any;
  renderer: any;
  public flag: any;
   color:any;
  
  taxLegislationList?: ICbicContentMst[];
  onlineServiceList?: ICbicContentMst[];
  manualServiceList?: ICbicContentMst[];
  gstRateServiceList?: ICbicContentMst[];
  miscellaneousServiceList?: ICbicContentMst[];
  gstUpdatesList?: ICbicContentMst[];
  constructor(private sessionStorageService: SessionStorageService,private contentMstService: CbicContentMstService, 
    private changeLnService: ChangeLanguageService) { }

  isDataAvailable(){
    let dataAvailable = true;
    dataAvailable &&= this.taxLegislationList !=null && this.taxLegislationList.length!==0;
    if(dataAvailable){
      dataAvailable &&= this.onlineServiceList !=null && this.onlineServiceList.length!==0;  
    }
    if(dataAvailable){
      dataAvailable &&= this.manualServiceList !=null && this.manualServiceList.length!==0;  
    }
    if(dataAvailable){
      dataAvailable &&= this.gstRateServiceList !=null && this.gstRateServiceList.length!==0;  
    }
    if(dataAvailable){
      dataAvailable &&= this.miscellaneousServiceList !=null && this.miscellaneousServiceList.length!==0;  
    }
    if(dataAvailable){
      dataAvailable &&= this.gstUpdatesList !=null && this.gstUpdatesList.length!==0;  
    }
    return dataAvailable;
   };

  ngOnInit(): void {
    //  GSTComponent.constructor();
    this.gettaxLegislation();
    this.getonlineService();
    this.getmannualService();
    this.getgstRatesService();
    this.getmiscellaneousService();
    this.getgstUpdates();
    this.color = this.sessionStorageService.retrieve('colr');
  }

  gettaxLegislation(): void {
    this.contentMstService.getContentData('Tax-Legislation-GST').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          const usedLanguage = this.changeLnService.getLanguage();

          if (usedLanguage === 'hi') {
            this.flag ='Hi';
            
          } else {
            this.flag = 'En';
            
          }
          this.taxLegislationList = res.body;
        }
      }
    )
  }

  getonlineService(): void {
    this.contentMstService.getContentData('Online-Service-GST').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag ='Hi';
          } else {
            this.flag = 'En';
          } 
          this.onlineServiceList = res.body;
        }
      }
    )
  }

  getgstUpdates(): void {
    this.contentMstService.getContentData('Updates-GST').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          const usedLanguage = this.changeLnService.getLanguage();

          if (usedLanguage === 'hi') {
            this.flag ='Hi';
          } else {
            this.flag = 'En';
          }
          this.gstUpdatesList = res.body;
        }
      }
    )
  }

  getmannualService(): void {
    this.contentMstService.getContentData('Manuals-FAQs-GST').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          const usedLanguage = this.changeLnService.getLanguage();

          if (usedLanguage === 'hi') {
            this.flag ='Hi';
          } else {
            this.flag = 'En';
          }
          this.manualServiceList = res.body;
        }
      }
    )
  }

  getgstRatesService(): void {
    this.contentMstService.getContentData('GST-Rates-Ready-Reckoner-GST').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          const usedLanguage = this.changeLnService.getLanguage();

          if (usedLanguage === 'hi') {
            this.flag ='Hi';
          } else {
            this.flag = 'En';
          }
          this.gstRateServiceList = res.body;
        }
      }
    )
  }

  getmiscellaneousService(): void {
    this.contentMstService.getContentData('Miscellaneous-GST').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          const usedLanguage = this.changeLnService.getLanguage();

          if (usedLanguage === 'hi') {
            this.flag ='Hi';
          } else {
            this.flag = 'En';
          }
          this.miscellaneousServiceList = res.body;
        }
      }
    )
  }
}
